<script setup>
import {computed, onMounted, onUnmounted, ref, watch} from "vue";
import axios from "axios";
import {useRoute, useRouter} from "vue-router";
import HomeHeader from "@/components/HomeHeader.vue";
import Footer from "@/components/Footer.vue";
import {useHead} from "@vueuse/head";
import {useI18n} from "@/i18n";


const datalist = ref(null)
const route = useRoute()
const router = useRouter()
const {t} = useI18n()

const Keywords = ref()
const current = ref(1)

const lastPage = computed(() => {
  return Math.ceil(datalist.value.count / 12)
})

const prevPage = computed(() => {
  if (current.value > 1) {
    return current.value - 1;
  } else {
    return 1
  }
})

const nextPage = computed(() => {
  if (current.value < lastPage.value) {
    return current.value + 1;
  } else {
    return current.value
  }
})

const pages = computed(() => {
      const pages = []
      for (let i = 1; i <= lastPage.value; i++) {
        if (i === current.value || i === lastPage.value || (i >= current.value - 1 && i <= lastPage.value + 1)) {
          pages.push(i)
        } else if (pages[pages.length - 1] !== '...') {
          pages.push('...')
        }
      }
      return pages
    }
)

async function get_product() {
  try {
    let url = '/api/products/';
    const page = Number(route.query.page);
    const title = route.query.product_title;
    const category = route.query.category_id_category;
    const param = new URLSearchParams();

    if (page) {
      param.append('page', page);
    }
    if (title) {
      param.append('product_title', title);
    }
    if (category) {
      param.append('category_id_category', category);
    }

    url = url + '?' + param.toString();
    const response = await axios.get(url);
    datalist.value = response.data;
  } catch (error) {
    console.error('Error fetching products:', error);
  }
}

function getPageFromUrl() {
  const page = Number(route.query.page);
  return page ? page : 1
}

function getToPage(page) {
  current.value = page
  const query = {...route.query}
  query.page = page
  router.push({query})
}

function getSearch() {
  const search = Keywords.value.trim()
  router.push({
    query: {product_title: search}
  })
}

onMounted(() => {
  const scripts = [
    '/js/core.min.js',
    '/js/script.js'
  ];

  function loadScriptsSequentially(scripts, index = 0) {
    if (index < scripts.length) {
      const script = document.createElement('script');
      script.src = scripts[index];
      script.onload = () => loadScriptsSequentially(scripts, index + 1);
      document.body.appendChild(script);
    }
  }

  loadScriptsSequentially(scripts);

  current.value = getPageFromUrl()
  get_product()
  window.addEventListener('popstate', handleBrowserNavigation)
})

watch(() => route.query,
    () => {
      get_product()
    }, {immediate: true})

useHead({
  title: 'TPA Housing - 100000m2 Production Plant, 20 Years Experienced Engineer, 30 Countries House Projects',
  meta: [
    {
      name: 'description',
      content: 'content="We can provide prefabricated design expertise, construction knowledge you need to build the house you want in short time and within your budget,Steel Structure House Building,Warehouse Steel Structure,Lightweight Steel Structure and other products and services'
    }
  ]
})

onUnmounted(() => {
  window.removeEventListener('popstate', handleBrowserNavigation)
})

function handleBrowserNavigation() {
  window.location.reload()
}

</script>

<template>
  <div class="page">
    <HomeHeader/>

    <!-- Breadcrumbs -->
    <section class="bg-gray-7">
      <div class="breadcrumbs-custom box-transform-wrap context-dark">
        <div class="container">
          <h3 class="breadcrumbs-custom-title">{{ t('page.products') }}</h3>
          <div class="breadcrumbs-custom-decor"></div>
        </div>
        <div class="box-transform" style="background-image: url(/images/bg-shop.jpg);"></div>
      </div>
      <div class="container">
        <ul class="breadcrumbs-custom-path">
          <li><a href="/">{{ t('common.home') }}</a></li>
          <li class="active"><a href="/products">{{ t('page.products') }}</a></li>
        </ul>
      </div>
    </section>
    <!-- Section Shop-->
    <section class="section section-lg bg-default text-md-start">
      <div class="container">
        <div class="row row-60">
          <div class="col-lg-4 col-xl-3">
            <div class="aside row row-60">
              <div class="aside-item col-sm-6 col-lg-12">
                <h6 class="aside-title">{{ t('common.category') }}</h6>
                <ul class="list-marked-2">
                  <li><a :href="'?category_id_category=steel structure'">Steel Structure</a></li>
                  <li><a :href="'?category_id_category=Steel House'">Steel House</a></li>
                </ul>
                <!-- RD Search Form-->
                <form class="form-search rd-search form-search" action="" method="GET">
                  <div class="form-wrap">
                    <label class="form-label" for="search-form">{{ t('common.search') }}</label>
                    <input v-model="Keywords" class="form-input" id="search-form" type="text" name="s"
                           autocomplete="off">
                    <button v-on:click.prevent="getSearch" class="button-search fl-bigmug-line-search74"
                            type="submit"></button>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div class="col-lg-8 col-xl-9">
            <div class="row row-30 row-md-40 row-xl-60">
              <div class="col-sm-6 col-xl-4" v-if="datalist && datalist.results" v-for="list in datalist.results"
                   :key="list.id">
                <!-- Product-->
                <article class="product">
                  <!-- 图片容器增加自定义类名 -->
                  <div class="product-figure image-lg">
                    <!-- 图片去掉固定尺寸，让CSS控制 -->
                    <img :src="list.image_1" :alt="list.product_title" class="product-img-lg"/>
                  </div>
                  <!-- 文字增加自定义类名 -->
                  <h6 class="product-title title-lg text-center">{{ list.product_title }}</h6>
                  <div class="product-button">
                    <div class="button-wrap">
                      <a class="button button-xs button-secondary button-winona"
                         :href="'/products/' + list.site">{{ t('common.viewProduct') }}</a>
                    </div>
                  </div>
                </article>
              </div>
            </div>
            <div class="pagination-wrap">
              <!-- Bootstrap Pagination-->
              <nav aria-label="Page navigation">
                <ul class="pagination">
                  <li @click="getToPage(prevPage)" class="page-item page-item-control"><a class="page-link"
                                                                                          href="#"
                                                                                          aria-label="Previous"><span
                      class="icon"
                      aria-hidden="true"></span></a>
                  </li>
                  <li v-if="datalist && datalist.results" v-for="page in pages" :key="page" class="page-item active">
                    <a v-if="page === current.value" @click="getToPage(page)" class="page-link" href="#">{{ page }}</a>
                    <a v-else-if="page === '...'" @click="getToPage(page)" class="page-link" href="#">{{ page }}</a>
                    <a v-else @click="getToPage(page)" class="page-link" href="#">{{ page }}</a>
                  </li>

                  <li @click="getToPage(nextPage)" class="page-item page-item-control"><a class="page-link" href="#"
                                                                                          aria-label="Next"><span
                      class="icon" aria-hidden="true"></span></a></li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </section>

    <Footer/>
  </div>
  <!-- Global Mailform Output-->
  <div class="snackbars" id="form-output-global"></div>
</template>

<style scoped lang="scss">
.product {
  width: 100%;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden; /* 防止内容溢出 */
}
</style>
